import IngredientsForm from './IngredientsForm';

export default IngredientsForm;
